import { BasicProps } from "./ComponentsInterface";
import classnames from "classnames";

export const LButtonGroup = ({ ...props }: ButtonGroupProps): JSX.Element => {
    const classes = classnames(props.className, "buttons", "is-centered", props.extraSpacing ? "section" : "");

    return <div className={classes}>{props.children}</div>;
};

interface ButtonGroupProps extends BasicProps {
    extraSpacing?: boolean;
}
